<!-- src/components/AlertBox.vue -->
<template>
  <div v-if="visible" class="alert-box">
    <div class="alert-box-header">
      <h3>{{ title }}</h3>
    </div>
    <div class="alert-box-body">
      <p>{{ text }}</p>
    </div>
    <div class="alert-box-footer">
      <button @click="closeAlert">OK</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      visible: true
    };
  },
  methods: {
    closeAlert() {
      this.visible = false;
      this.$emit('close'); // Emit close event
    }
  }
};
</script>

<style scoped>
.alert-box {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  padding: 20px;
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  width: 300px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.alert-box-header {
  margin-bottom: 10px;
}

.alert-box-footer {
  text-align: center;
}

.alert-box-footer button {
  padding: 5px 15px;
  background-color: #f5c6cb;
  color: #721c24;
  border: none;
  cursor: pointer;
}
</style>
